import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { FeatureValue } from '../../../../lib-feature-decision/decorators/feature-value.decorator';
import { ParcoursDsdFeatures } from '../../../../parcours-dsd/parcours-dsd.features';
import { AppConfigService } from '../../../../app-config.service';
import { NavigatePageAccueil, NavigatePageResultat } from '../../capacite.actions';
import { StatusCapaciteEnum } from '../../constants/status-capacite.enum';
import { ResultatDataModel } from '../../modeles/resultat-data.model';
import { CapaciteSelectors } from '../../capacite.selectors';

@Component({
  selector: 'app-dashboard-card-status',
  templateUrl: './dashboard-card-status.component.html',
  styleUrls: ['./dashboard-card-status.component.scss'],
  standalone: false
})
export class DashboardCardStatusComponent implements OnInit, OnDestroy {
  StatusCapacite = StatusCapaciteEnum;

  @FeatureValue(ParcoursDsdFeatures.CapaciteDisabled)
  isCapaciteDisabled: boolean;

  @Select(CapaciteSelectors.donneesPageResultat)
  donnees$: Observable<ResultatDataModel>;
  donnees: ResultatDataModel;
  donneesSubscription: Subscription;

  @Select(CapaciteSelectors.statutCapacite)
  statusCapacite$: Observable<StatusCapaciteEnum>;
  @Select(CapaciteSelectors.isCapacityCompleted)
  isCapacityCompleted$: Observable<boolean>;
  @Select(CapaciteSelectors.isCapacityStarted)
  isCapacityStarted$: Observable<boolean>;

  valeurProprieteRealiste: number;
  versementMensuelRealiste: number;
  valeurProprieteMaximale: number;
  versementMensuelMaximale: number;

  typeProjet: string;

  constructor(private readonly store: Store, private readonly _appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.fetchCapacite();
    this.typeProjet = this._appConfigService.typeProjet;
  }

  ngOnDestroy() {
    if (this.donneesSubscription) {
      this.donneesSubscription.unsubscribe();
    }
  }

  private fetchCapacite() {
    this.donneesSubscription = this.donnees$.subscribe(donnees => {
      this.donnees = donnees;
      if (this.donnees) {
        this.valeurProprieteRealiste = this.donnees.realiste.valeurPropriete;
        this.versementMensuelRealiste = this.donnees.realiste.versementMensuel;
        this.valeurProprieteMaximale = this.donnees.maximale.valeurPropriete;
        this.versementMensuelMaximale = this.donnees.maximale.versementMensuel;
      }
    });
  }

  get hasOnlyRealisticCapacity() {
    return this.valeurProprieteRealiste === this.valeurProprieteMaximale;
  }

  navigatePageResultat() {
    this.store.dispatch(new NavigatePageResultat());
  }

  navigatePageAccueil() {
    this.store.dispatch(new NavigatePageAccueil());
  }
}
